import React from 'react';
import { Edit3 } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Empty-results fallback. Rendered when a tab's search returns total=0
 * and the response includes a `fallback_suggestion`.
 *
 * Props:
 *   suggestion: { message, suggested_tabs[], action?, prefill_upc? }
 *   query: the current search query (used for "Create manual entry '...'")
 *   onTryTab(tabKey): switch to suggested tab carrying the current query
 *   onCreateManual(prefillName): open manual entry flow with optional prefill
 */
const TAB_LABELS = {
  foods: 'Foods',
  restaurants: 'Restaurants',
  meals: 'Meals',
  manual: 'Manual',
};

export default function FallbackChips({ suggestion, query, onTryTab, onCreateManual }) {
  if (!suggestion) return null;
  const tabs = Array.isArray(suggestion.suggested_tabs) ? suggestion.suggested_tabs : [];

  return (
    <div
      className="px-4 py-8 text-center space-y-4"
      data-testid="fallback-chips"
    >
      <p className="text-sm text-muted-foreground">{suggestion.message}</p>
      {tabs.length > 0 && (
        <div className="flex flex-wrap items-center justify-center gap-2">
          {tabs.map(function (tabKey) {
            return (
              <Button
                key={tabKey}
                size="sm"
                variant="outline"
                onClick={function () { onTryTab && onTryTab(tabKey); }}
                data-testid={'fallback-chip-' + tabKey}
              >
                {TAB_LABELS[tabKey] || tabKey}
              </Button>
            );
          })}
        </div>
      )}
      {onCreateManual && (
        <div className="pt-2">
          <Button
            size="sm"
            variant="default"
            onClick={function () { onCreateManual(query); }}
            className="gap-2"
            data-testid="fallback-create-manual"
          >
            <Edit3 className="size-4" />
            {query
              ? 'Create manual entry "' + query + '"'
              : 'Create manual entry'}
          </Button>
        </div>
      )}
    </div>
  );
}
